<template>

  <div class="Quest" :class="theme">
  
  <!-- Videocont is ads, renamed because of adblock -->
  <transition name="slideUpBig">
    <videoCont v-if="videoMov" @close-video="closeVideo" :videoMov="videoMov"></videoCont>
  </transition>

  <Tictac @gameOver="gameOver" v-if="gameOpen == 'game-tictactoe' "></Tictac>


  <spaceBattle @gameOver="gameOver" v-if="gameOpen == 'game-spaceBattle' "></spaceBattle>


    <!-- <div class="curSlide"> ❤️ {{ this.$store.state.player.adChance }} <span>{{ this.$store.state.curSlide }} </span></div> -->

    <div class="curSlide"> ❤️ {{ this.$store.state.player.adChance }} <span> 💎 {{ this.$store.state.mana }} </span></div>

    <div class="image">
      <transition name="slideUp" mode="out-in">
        <img v-bind:src="imageLink" :key="imageLink"> 
      </transition>
    </div>

      <transition-group name="list-complete" tag="ul" class="messages" mode="out-in">
          <li v-for="msg in messages" :key="msg.text" class="list-complete-item">
            {{ msg.text }}
          </li>
      </transition-group>

      <!-- <transition-group name="buttons" tag="ul" class="buttons" id="buttonsElem" mode="out-in">  -->
        <ul class="buttons" id="buttonsElem">
          <!-- <li v-for="action in actions" @click="loadNext(action.nextId)" :key="action.text" class="buttons-item"> -->
          <li v-for="action in actions" @click="loadNext(action.nextId)" :key="action.text" class="buttons-item">
            <span>{{ action.text }}</span>
            <div class="skew"></div>
          </li>
        </ul>
      <!-- </transition-group> -->
  </div>
</template>



<script>

import videoCont from './videoCont.vue'
import Tictac from './Tictac.vue'
import spaceBattle from './spaceBattle.vue'

export default {

  name: 'Quest',

  components: {
    videoCont,
    Tictac,
    spaceBattle
  },

  data (){
    return {

      jsonLink: './data/hell.json',

      // progress
      Quest: '', // Whole array
      curQuest: this.$store.state.curQuest,
      curSlide: this.$store.state.curSlide, // current slide name
      prevId: this.$store.state.prevId,

      theme: 'nomatter',
    
      player: this.$store.state.player,
      // items: this.$store.state.items,

      
      chainMsg: 1, // displayed messages
      messagesCount: 1, // total messages in array

      messages: [],
      actions: [],
      imageLink: '', // path to the image

      videoMov: false, // advertising
      gameOpen: '', // mini game
      justLoaded: true,

      delayButtons: 1000,
      music: false // temp

    }
  },

  computed: {
      jsonHell: function(){

        return this.$resource( './data/hell.json' ) // path to the json file
      }

  },

  methods: {

    loadNext(nextId){

      document.querySelector('#app').classList.remove( this.theme )
      document.querySelector('body').classList.remove( this.theme )

      
      // Manually adding out animation for buttons
      if( this.chainMsg == this.messagesCount || this.messagesCount == 1 || this.chainMsg == 1){
        document.querySelector('.buttons').classList.add( "buttonsOut" )
        document.querySelector('.buttons').classList.remove('clicky')
      }

      document.querySelector('.buttons').classList.remove('clicky')
      setTimeout( () => { 
        document.querySelector('.buttons').classList.add('clicky')
      }, this.delayButtons)



      // adding clicked class to the relevant element
      try {

        event.path[1].classList.add('button-click')

        setTimeout( () => { 
          document.querySelector('.buttons').classList.remove('clicky')
        }, 200)

      } catch(err){
        
      }


      // syncing vuex and this data
      this.curQuest = this.$store.state.curQuest
      this.curSlide = this.$store.state.curSlide 
      this.prevId = this.$store.state.prevId

      // Back button
      if( nextId == 'prevId'){
        return this.loadNext(this.prevId)
      }

      // Back load from checkpoint
      if( nextId == 'checkpoint'){
        return this.loadNext(this.$store.state.checkPoint)
      }


      // if next id starts with videoCont - show video ad
      if( nextId == 'videoCont'){
        return this.openVideo()
      }

      if ( nextId.startsWith('game')) {
        return this.openGame(nextId)
      }

      // restarting
      if(nextId == 'reset'){
        this.$store.commit('reset')
        this.$store.commit('addHidden', 'first') 
        this.loadNext('(Aurora)00-disclaimer')
        return
      }

      // if slide name has (someName), go to a new quest
      if( nextId.startsWith("(") ){
          let re = /\((.*)\)/;

          let newQuest = nextId.match(re)[1] // new quest name

          this.curQuest = newQuest
          this.$store.commit('saveCurQuest', newQuest)
          nextId = nextId.slice(newQuest.length + 2)
          setTimeout( () => { this.actionEvent(nextId) }, 1)
          return
      }

      else {
        if ( this.Quest[this.curQuest][nextId] !== undefined ){
          setTimeout( () => { this.actionEvent(nextId) }, 10)
        }

        else {
          // if something went wrong
          alert('Can not load next slide: ' + nextId + '. Try choosing other option')
          console.log('error')
          console.log( 'Array: ' + this.Quest[this.curQuest] )
          console.log( 'NextId:' + nextId)

          this.$ga.event({
            eventCategory: 'ERROR',
            eventAction: this.curQuest,
            eventLabel: nextId,
            eventValue: this.$store.state.mana
          })
        }
      }
      
    },


     actionEvent(nextId){

      // temporary - for the end music
      if(nextId == 'the-end' && !this.music ){
        
        this.music = true

        let audio = new Audio('assets/the-end.mp3')
        audio.play()


        // game finis analytics event
        this.$ga.event({
          eventCategory: 'FINISH',
          eventAction: 'Narrative' + this.$store.state.narrative,
          eventValue: this.$store.state.mana
        })
      }
      
      setTimeout( () => { 
        document.querySelector('.buttons').classList.remove( "buttonsOut" ) // Out
      }, 1000 )



      // document.querySelector('.buttons').classList.remove( "buttonsOut" )


      const slideArr = this.Quest[this.curQuest][nextId] // slide array
      this.$store.commit('saveCurSlide', nextId)


      // if nextID starts with router - will check conditions property
      if (nextId.startsWith("router")){

        let narrative = this.$store.state.player.narrative
        let items = this.$store.state.items
        let hidden = this.$store.state.hidden

        let i;

        for ( i = 0; i < slideArr.conditions.length; i++ ){

          let option = slideArr.conditions[i].option

          if( narrative.includes(option) || items.includes(option) || hidden.includes(option)){
            return this.loadNext( slideArr.conditions[i].nextId )
          } 
        }
      } 

      // how many lines of text
      this.messagesCount = Object.keys(slideArr.messages).length 
      this.playerCharacter(slideArr)
      
      // checking if array has adChance
      if ( typeof slideArr.adChance === 'undefined' ) {
        this.prevId = '(' + this.curQuest + ')' + nextId
        this.$store.commit('savePrevId', this.prevId)
      }

      // save checkpoint
      if( slideArr.checkpoint ){
        this.$store.commit('saveCheckPoint', slideArr.checkpoint)
      }

      if (nextId.endsWith('death')){

        this.$ga.event({
          eventCategory: 'DEATH',
          eventAction: this.curQuest,
          eventLabel: nextId,
          eventValue: this.$store.state.mana
        })        

      }

      // if user has no more ad chances, remove "Take another chance" button
      if(nextId.endsWith('death') && this.$store.state.player.adChance <= 0) {

        this.$ga.event({
          eventCategory: 'DEATH - NO CHANCE',
          eventAction: this.curQuest,
          eventLabel: nextId,
          eventValue: this.$store.state.mana
        })


        if( this.messagesCount == 1) { 
          setTimeout( () => { 
            document.querySelector(".Quest").classList.add('no-chance') // removing first button
          }, 1)
        }

        if( this.chainMsg == this.messagesCount ){
         setTimeout( () => { 
            document.querySelector(".Quest").classList.add('no-chance') // removing first button
          }, 1)
        }

      }

      // CHAINY: showing messages one by one, if message array is bigger than 
       if ( this.messagesCount > 1 && this.chainMsg != this.messagesCount ){


          // console.log( "message " + this.chainMsg + " of " + messagesCount )
          setTimeout( () => { this.chainMsg += 1 },10)
          document.getElementById("buttonsElem").classList.add("continiues")

          this.messages = slideArr.messages.slice(0, this.chainMsg)

        setTimeout( () => { 
          this.actions =  [ {"text" : "...", "nextId" : nextId  }]
        }, this.delayButtons)
          
          this.imageLink = "assets/empty.svg"
          this.theme = slideArr.theme
          document.querySelector('#app').classList.add( this.theme )
          document.querySelector('body').classList.add( this.theme )
          return
        }

        // REGULAR message
        document.getElementById("buttonsElem").classList.remove("continiues")

        setTimeout( () => { 
          this.actions = slideArr.actions
        }, this.delayButtons )

        // google analytics for next slide
        this.$ga.event({
          eventCategory: 'Quest',
          eventAction: this.curQuest,
          eventLabel: nextId,
          eventValue: this.$store.state.mana
        })

        this.messages = slideArr.messages
        
        this.imageLink = "assets/" + slideArr.img
        this.chainMsg = 1
        this.theme = slideArr.theme
        document.querySelector('#app').classList.add( this.theme )
        document.querySelector('body').classList.add( this.theme )
        this.$store.commit('addMana')
        this.justLoaded = false
        return

      },

      playerCharacter(slideArr){


        // defining players character
        if (slideArr.player){


          if(slideArr.player.narrative !== undefined){
            this.$store.commit('changeNarrative', slideArr.player.narrative)
          }

          // to avoid multiplying points on page reload

          if( !this.justLoaded && this.chainMsg == this.messagesCount ){
            console.log( 'chainMsg' ,this.chainMsg == 1 )


            // adding points
            if(slideArr.player.good !== undefined){
              console.log('Good + 1')
              this.$store.commit('addGood', slideArr.player.good)
            }

            if(slideArr.player.evil !== undefined){
              console.log('evil + 1')
              this.$store.commit('addEvil', slideArr.player.evil)
            
            }

            if(slideArr.player.lol !== undefined){
              console.log('lol + 1')
              this.$store.commit('addLol', slideArr.player.lol)
            }

            if(slideArr.player.adChance !== undefined){
              this.$store.commit('addChance', slideArr.player.adChance)
            }

          }
        }

        if(slideArr.item !== undefined){
          this.$store.commit('addItem', slideArr.item)
        }

        if(slideArr.hidden !== undefined){
          this.$store.commit('addHidden', slideArr.hidden)
        }

        if(slideArr.hiddenRem !== undefined){
          this.$store.commit('remHidden', slideArr.hiddenRem)          
        }

        if(slideArr.itemRem !== undefined){
          this.$store.commit('remItem', slideArr.itemRem)          
        }
      },


      openVideo(){
        this.videoMov = true
        // document.querySelector('#videoSrc').play()

        // watching ad will save user from death only once
        this.$store.commit('minChance', 1)

        this.$ga.event({
          eventCategory: 'ADV',
          eventAction: this.curQuest,
          eventLabel: this.prevId,
          eventValue: this.$store.state.mana
        })
      },

      openGame(gameName){
        console.log(gameName)
        this.gameOpen = gameName
        // console.log('openGame')
      },

      gameOver(nextId){
        this.gameOpen = ''
        this.loadNext(nextId)
        return
      },

      closeVideo(){
        this.videoMov = false
        // document.querySelector('#videoSrc').pause()
        // document.querySelector('.videoCont').classList.remove('adActive')
        document.querySelector('.Quest').classList.remove('noCurslide')
        this.loadNext(this.$store.state.checkPoint)
      },

      // function to load progress item from local storage

      loadProgress(localName){
        if(localStorage.getItem(localName)){
          try{
            this[localName] = JSON.parse(localStorage.getItem(localName))
            // this[localName] = localStorage.getItem(localName);

          } catch(e) {
            localStorage.removeItem(localName)
            console.log("Load error on", localName)
          }
        }
      },

      onOpen(){
          // loading current game progress
          let checkPointLoad = this.$store.state.checkpointLoad

          if(checkPointLoad){
              this.loadNext( "(meow-evil)meow-evil-01-food-catch-talk" ),
              // this.loadNext( this.$store.state.checkPoint )
              this.$store.commit('checkFalse')
              document.querySelector('#app').className = ''
              document.querySelector('body').className = ''
              document.querySelector('body').classList.add("playmodeEnabled")
              return
          }

          if ( this.curSlide !== '' )
          {
            this.loadNext(this.curSlide)
          } 

          else {
            this.loadNext( '(Aurora)00-disclaimer' )
            this.$store.commit('addHidden', 'first') 
          }
      }

  },

  created(){
    this.jsonHell.get().then(response => {

      this.Quest = response.data
      this.onOpen()


    }, response => {
      console.log('Error loading json')
    });

    // creating browser close event for Analytics
    window.addEventListener('beforeunload', function (event) {
      console.log('leaving') // logs to my logger
    }, false)
  }
}


</script>